import { styled } from '@mui/material';

export const ContentStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: '1.5rem',
  flexDirection: 'column',
  width: '100%',
  alignItems: 'center',

  padding: '0 2rem 1rem 2rem',
}));

export const AlignButtons = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '0.5rem',

  [theme.breakpoints.up('sm')]: {
    justifyContent: 'center',
  },
}));
